import { Color, Container, FillGradient, Sprite, Text, TextStyle } from "pixi.js";

import { Spine } from "@esotericsoftware/spine-pixi-v8";
import { Group, Tween } from "tweedle.js";
import { languageGlobal } from "../config/GlobalVariableConfig";
import { getFontConfig } from "../config/introTextConfig";
import { MaxGameWidthHeight } from "../config/reelConfig";

declare const window: any;
const translationManager = window.hacksawCasino.Translation;


export class IntroScene extends Container {
    // public loaderBar: Container = new Container();

    private allTextContainer: Container = new Container();

    private volatilityContainer: Container = new Container();
    private continueButtonContainer: Container = new Container();

    private tileContainer1 = new Container();
    private tileContainer2 = new Container();
    private tileContainer3 = new Container();
    private tileIndex: number = 0;
    private animationInterval: any;

    private tweenGroupForTiles: Group = new Group();
    private tweenGroupForScale: Group = new Group();
    private tweenGroupForBreath: Group = new Group();

    private logo = Spine.from({
        skeleton: "logoSkel",
        atlas: "logoAtlas",
    });

    private screenWidth: number = 0;
    private screenHeight: number = 0;

    constructor() {
        super();

        this.eventMode = 'static';
        this.interactive = true;

        // this.addChild(this.allTextContainer);


        console.log("languageGlobal", languageGlobal)


        document.addEventListener("visibilitychange", this.handleVisibilityChange);


    }

    override destroy(): void {
        document.removeEventListener("visibilitychange", this.handleVisibilityChange);

        super.destroy({ children: true });
    }

    private handleVisibilityChange = (): void => {
        if (document.hidden) {
            this.endTileAnimation(); // Pause animation
        } else {
            // Restart animation if in portrait mode
            const isLandscape = this.screenWidth > this.screenHeight;
            if (!isLandscape) {
                this.startTileAnimation();
            }
        }
    };

    private backgroundImage: Sprite;
    public async showInitLogo(screenWidth: number, screenHeight: number) {

        this.screenWidth = screenWidth;
        this.screenHeight = screenHeight;


        this.backgroundImage = Sprite.from('introBG');

        this.addChild(this.backgroundImage);
        this.addChild(this.allTextContainer);


        // const logo: Sprite = Sprite.from('logoStatic');
        // logo.scale = 1;
        // logo.anchor = 0.5;
        // logo.position.set(1490, 1080);
        // this.allTextContainer.addChild(logo);


        this.logo.state.setAnimation(0, "logo", true);
        this.logo.scale = 1;
        this.allTextContainer.addChild(this.logo);

        this.setupVolatilityText();

        /*------------------------------------- */

        // this.tileContainer1.position.set(870, 1620);
        this.allTextContainer.addChild(this.tileContainer1);

        const tileImage1 = "image1";
        const headingTextVal1 = translationManager.game('intro_ticket_heading_1_uc');//"WILD LOOT";
        const descTextVal1 = translationManager.game('intro_ticket_desc_1');//"Winning symbols burst away and a random number of wilds fill the gaps on reels 2-4!";

        this.setupTile(this.tileContainer1, tileImage1, headingTextVal1, descTextVal1, "ticket_1");

        /*------------------------------------- */

        // this.tileContainer2.position.set(1500, 1509);
        this.allTextContainer.addChild(this.tileContainer2);

        const tileImage2 = "image2";
        const headingTextVal2 = translationManager.game('intro_ticket_heading_2_uc');//"MULTIPLIER MANIA";
        const descTextVal2 = translationManager.game('intro_ticket_desc_2');//"Multipliers up to 100x may appear on wilds, boosting wins and accumulating for epic payouts!";

        this.setupTile(this.tileContainer2, tileImage2, headingTextVal2, descTextVal2, "ticket_2");

        /*------------------------------------- */

        // this.tileContainer3.position.set(2130, 1620);
        this.allTextContainer.addChild(this.tileContainer3);

        const tileImage3 = "image3";
        const headingTextVal3 = translationManager.game('intro_ticket_heading_3_uc');//"8-BIT BONUS";
        const descTextVal3 = translationManager.game('intro_ticket_desc_3');//"Earn bigger multipliers in free spins that accumulate and persist throughout the bonus game!Earn bigger multipliers in free spins that accumulate and persist throughout the bonus game!";

        this.setupTile(this.tileContainer3, tileImage3, headingTextVal3, descTextVal3, "ticket_1");

        /*------------------------------------- */

        this.setupContinueButton();

        let currentVal: number = .75;
        let targetVal: number = 1;
        new Tween({ x: currentVal }, this.tweenGroupForScale)
            .to({ x: targetVal }, 300)
            .onComplete(() => {
                this.tweenGroupForScale.removeAll();
            })
            .onUpdate((object) => {
                currentVal = object.x; // Update currentVal with the tweened value
                this.resize(this.screenWidth, this.screenHeight, currentVal);
            })
            .start();
    }


    private createTileBase(animationName: string): Spine {
        const tileBase = Spine.from({
            skeleton: "ticketBaseSkel",
            atlas: "ticketBaseAtlas",
        });

        tileBase.state.setAnimation(0, animationName, true);

        tileBase.scale.set(0.7);
        tileBase.position.set(0, 0);

        return tileBase;
    }

    private setupTile(tileContainer1: Container, tileImageName: string, headingTextVal: string, descTextVal: string, animationName: string): void {

        const tileBase = this.createTileBase(animationName);
        tileContainer1.addChild(tileBase);

        let imageScale = 0.75;
        let imageY = -100;
        let headingY = 50;
        let descY = 185;

        const tileImage: Sprite = Sprite.from(tileImageName);
        tileImage.anchor = 0.5;
        tileImage.scale = imageScale;
        tileImage.position.set(0, imageY);
        tileContainer1.addChild(tileImage);

        const {
            fontFamily: fontFamilyHeading,
            fontWeight: fontWeightHeading,
            fontSize: fontSizeHeading,
            letterSpacing: letterSpacingHeading,
            lineHeight: lineHeightHeading
        } = getFontConfig(languageGlobal, "heading");


        // const fill = new FillGradient(0, 0, 0, 32 * 1 * 3);
        // const colors = ["#ffffff", "#ffca3b"].map((color) => Color.shared.setValue(color).toNumber());

        // colors.forEach((number, index) => {
        //     const ratio = index / colors.length;

        //     fill.addColorStop(ratio, number);
        // });

        const headingText = new Text({
            text: headingTextVal,
            style: {
                fontFamily: fontFamilyHeading,
                fill: "#ffffff",
                fontWeight: fontWeightHeading,
                fontSize: fontSizeHeading,
                stroke: {
                    color: "#25a7f8",
                    width: 3,
                },
                // dropShadow:
                // {
                //     blur: 20,
                //     color: "#5333f4",
                //     distance: 10,
                // },
                letterSpacing: letterSpacingHeading,
                wordWrap: true,
                wordWrapWidth: 350,
                align: "center",
                lineHeight: lineHeightHeading,
                breakWords: true,

            }
        });

        headingText.anchor.set(0.5, 0.5);
        headingText.position.set(0, headingY);
        tileContainer1.addChild(headingText);



        const {
            fontFamily: fontFamilyDesc,
            fontWeight: fontWeightDesc,
            fontSize: fontSizeDesc,
            letterSpacing: letterSpacingDesc,
            lineHeight: lineHeightDesc
        } = getFontConfig(languageGlobal, "description");

        let text = "";
 
        if (["id-id", "de-de", "es-es", "el-gr", "da-dk", "vi-vn", "pt-br", "it-it", "tr-tr", "nl-nl", "ro-ro", "hr-hr"].includes(languageGlobal)) {
            text = "10.000x";
        } else if (["en-us", "es-pe", "ja-jp", "zh-cn", "zh-tw", "th-th", "ko-kr"].includes(languageGlobal)) {
            text = "10,000x";
        } else if (["fi-fi", "no-no", "pl-pl", "sv-se", "fr-fr", "lv-lv", "ru-ru", "bg-bg", "lt-lt", "hu-hu", "pt-pt", "cs-cz"].includes(languageGlobal)) {
            text = "10\u00A0000x";
        }
        if (tileImageName == "image3") {
            const fill = new FillGradient(0, 0, 0, 32 * 1 * 3);
            const colors = ["#faf7eb"].map((color) => Color.shared.setValue(color).toNumber());
 
            colors.forEach((number, index) => {
                const ratio = index / colors.length;
 
                fill.addColorStop(ratio, number);
            });
            const maxWinText = new Text({
            text: text,
            style: {
                fontFamily: "UnifrakturCook",
                fill: { fill },
                fontWeight: "600",
                fontSize: 65,
                // fontSize: 28,
                stroke: {
                    color: "#e5a53e",
                    width: 2,
                },
                dropShadow:
                {
                    blur: 5,
                    color: "#1a0803",
                    distance: 0,
                },
                letterSpacing: 1,//1,
                wordWrap: true,
                wordWrapWidth: 375,
                align: "center",
                lineHeight: 50,//50
                breakWords: true,
 
            }
        });
        tileContainer1.addChild(maxWinText);
        maxWinText.anchor.set(0.5);
        maxWinText.zIndex = 1;
        maxWinText.position.set(0,-105);
        }

        const descriptionTextStyle = new TextStyle({
            fontFamily: fontFamilyDesc,//"\"Comic Sans MS\", cursive, sans-serif", //Helvetica",//upheavtt", "nokiafc22"
            fill: "#ffffff",
            fontWeight: fontWeightDesc,
            fontSize: fontSizeDesc,

            align: "center",
            wordWrap: true,
            // trim: true,
            letterSpacing: letterSpacingDesc,
            ...(lineHeightDesc != null && { lineHeight: lineHeightDesc }), // only include if not null or undefined
            breakWords: true,

        });

        const descriptionText = new Text({
            text: descTextVal,
            style: descriptionTextStyle
        });

        // if (tileImageName == "image3") {
        //     descriptionText.style.wordWrapWidth = 360;
        // } else {
        descriptionText.style.wordWrapWidth = 350;
        while (descriptionText.height > 200) {
            descriptionText.style.fontSize -= 1;
        }
        // }
        ["zh-cn", "zh-tw"].forEach((lang)=>{
            if(languageGlobal === lang){
                descriptionText.style.fontSize = 30;
            }
        })

        descriptionText.anchor.set(0.5, 0.5);
        descriptionText.position.set(0, descY);
        tileContainer1.addChild(descriptionText);


    }

    public update() {

        this.tweenGroupForScale.update();
        this.tweenGroupForTiles.update();
        this.tweenGroupForBreath.update();
    }



    private setupVolatilityText(): void {


        this.volatilityContainer = new Container();


        // const volatilityBase: Sprite = Sprite.from('volatilityBase');
        // volatilityBase.anchor = 0.5;
        // this.volatilityContainer.addChild(volatilityBase);



        this.allTextContainer.addChild(this.volatilityContainer);

        // const fill = new FillGradient(0, 0, 0, 32 * 1 * 3);
        // const colors = ["#ffffff", "#ffca3b"].map((color) => Color.shared.setValue(color).toNumber());

        // colors.forEach((number, index) => {
        //     const ratio = index / colors.length;

        //     fill.addColorStop(ratio, number);
        // });

        const {
            fontFamily: fontFamilyVal,
            fontWeight: fontWeightVal,
            fontSize: fontSizeVal,
        } = getFontConfig(languageGlobal, "volatility");


        const text = new Text({
            text: translationManager.game('intro_volatility_uc'),//'VOLATILITY',
            style: {
                fontFamily: fontFamilyVal,
                fill: "#ffffff",
                stroke: {
                    color: "#25a7f8",
                    width: 3,
                },
                // dropShadow:
                // {
                //     blur: 15,
                //     color: "#2e00b1",
                //     distance: 6,
                // },
                fontSize: fontSizeVal,
                fontWeight: fontWeightVal,
            }
        });



        text.anchor.set(0.5, 0.5);
        text.position.set(-100, 3);

        const textScale = Math.min(220 / text.width, 1);
        text.scale = textScale;

        this.volatilityContainer.addChild(text);

        // volatilityBase.position.set(20 + text.width / 2, -2);


        // Define the volatility value
        const volatilityVal = 3; // Example value

        // Adding 5 vol images in a line
        const volSpacing = 60; // Space between each vol
        const volStartX = Math.min(35, -55 + text.width / 2); // Starting position to center vols

        for (let i = 0; i < 5; i++) {
            const volTexture = i < volatilityVal ? 'volatilityOn' : 'volatilityOff';
            const vol = Sprite.from(volTexture);
            vol.scale = 0.9;
            vol.anchor.set(0.5);
            vol.position.set(volStartX + i * volSpacing, 0); // Adjust Y position as needed
            this.volatilityContainer.addChild(vol);
        }

    }

    private setupContinueButton(): void {


        this.continueButtonContainer = new Container();
        // this.continueButtonContainer.cursor = 'pointer';
        // this.continueButtonContainer.eventMode = 'static';
        // this.continueButtonContainer.interactive = true;

        // const continueButtonBase: Sprite = Sprite.from('volatilityBase');
        // continueButtonBase.anchor = 0.5;
        // continueButtonBase.position.set(0, 2);

        // // this.continueButtonContainer.pivot.set(this.continueButtonContainer.width / 2, this.continueButtonContainer.height / 2)
        // this.continueButtonContainer.addChild(continueButtonBase);

        // this.continueButtonContainer.position.set(1500, 2300);
        this.allTextContainer.addChild(this.continueButtonContainer);

        // const fill = new FillGradient(0, 0, 0, 32 * 1 * 3);
        // const colors = ["#ffffff", "#ffca3b"].map((color) => Color.shared.setValue(color).toNumber());

        // colors.forEach((number, index) => {
        //     const ratio = index / colors.length;

        //     fill.addColorStop(ratio, number);
        // });

        const {
            fontFamily: fontFamilyVal,
            fontWeight: fontWeightVal,
            fontSize: fontSizeVal,
        } = getFontConfig(languageGlobal, "continue");


        const text = new Text({
            text: translationManager.game('intro_continue_uc'),//'Click to Continue',
            style: {
                fontFamily: fontFamilyVal,
                fill: "#ffffff",
                stroke: {
                    color: "#25a7f8",
                    width: 3,
                },
                // dropShadow:
                // {
                //     blur: 15,
                //     color: "#25a7f8",
                //     distance: 5,
                // },
                fontWeight: fontWeightVal,
                fontSize: fontSizeVal,
            }
        });


        text.anchor = 0.5;

        const currentScale = Math.min(440 / text.width, 1);
        text.scale = currentScale;

        text.position.set(0, 5);
        // text.position.set(continueButtonBase.width / 2, continueButtonBase.height / 2);

        this.continueButtonContainer.addChild(text);


        const tweenBreath = new Tween(text.scale, this.tweenGroupForBreath)
            .to({ x: currentScale * 1.03, y: currentScale * 1.03 }, 1000) // Scale up
            .yoyo(true) // Automatically reverses the tween
            .repeat(Infinity) // Infinite loop
            .onComplete(() => {
                this.tweenGroupForBreath.remove(tweenBreath);
            })
            .start();

        // this.continueButtonContainer.on('pointerover', () => {
        //     this.continueButtonContainer.tint = "#ffaa00";
        // });

        // this.continueButtonContainer.on('pointerout', () => {
        //     this.continueButtonContainer.tint = "#ffffff";
        // });

    }

    public resize(screenWidth: number, screenHeight: number, zoomFactor?: number): void {

        // console.log(`resize screenWidth${screenWidth} screenHeight ${screenHeight}`);

        this.screenWidth = screenWidth;
        this.screenHeight = screenHeight;

        const isLandscape = screenWidth > screenHeight;

        let portraitscale;
        if (!isLandscape) {
            this.startTileAnimation();
            portraitscale = 1.75;

            this.logo.scale = 0.9;
            this.logo.position.set(MaxGameWidthHeight / 2, 575);

            this.continueButtonContainer.scale = 1;
            this.continueButtonContainer.position.set(MaxGameWidthHeight / 2, 1520);

            this.volatilityContainer.scale = 0.9;
            this.volatilityContainer.position.set(970, 775);

        } else {
            this.landscapeTilePositions();
            this.endTileAnimation();

            portraitscale = 1;

            this.logo.scale = 0.8;
            this.logo.position.set(MaxGameWidthHeight / 2, 575);

            this.continueButtonContainer.scale = 1.2;
            this.continueButtonContainer.position.set(MaxGameWidthHeight / 2, 1520);

            this.volatilityContainer.scale = 1;
            this.volatilityContainer.position.set(970, 760);

        }


        const scale = portraitscale * (zoomFactor ? zoomFactor : 1) * Math.min(screenWidth / (isLandscape ? 1920 : 1080), screenHeight / (isLandscape ? 1080 : 1920));
        let bgScale;
        const BG_SCALE_FACTOR = Math.max(screenWidth / MaxGameWidthHeight, screenHeight / MaxGameWidthHeight);

        this.allTextContainer.scale.set(scale, scale);
        const xPos = (MaxGameWidthHeight * scale - this.screenWidth) / 2;
        const yPos = (MaxGameWidthHeight * scale - this.screenHeight) / 2;
        this.allTextContainer.x = -xPos;
        this.allTextContainer.y = -yPos;

        bgScale = Math.max(scale, BG_SCALE_FACTOR);
        this.backgroundImage.scale.set(bgScale, bgScale)
        const bgXPos = (MaxGameWidthHeight * bgScale - screenWidth) / 2;
        const bgYPos = (MaxGameWidthHeight * bgScale - screenHeight) / 2;
        this.backgroundImage.position.set(-bgXPos, -bgYPos);





    }

    public endTileAnimation(): void {
        clearInterval(this.animationInterval);
        this.isAnimatingTiles = false;
    }

    private landscapeTilePositions(): void {

        // this.tileIndex = 0;
        clearInterval(this.animationInterval);

        // Cancel any active tweens (assuming Tween.js has a way to cancel)
        this.tweenGroupForTiles.removeAll();

        this.tileContainer1.scale = 0.9;
        this.tileContainer1.position.set(405, 1130);
        this.tileContainer2.scale = 0.9;
        this.tileContainer2.position.set(MaxGameWidthHeight / 2, 1130); // Place off-screen to the right
        this.tileContainer3.scale = 0.9;
        this.tileContainer3.position.set(1650, 1130); // Place off-screen to the right
    }

    private isAnimatingTiles = false;

    private startTileAnimation(): void {
        if (this.isAnimatingTiles) return;
        this.isAnimatingTiles = true;

        this.resetTilePositions();
        clearInterval(this.animationInterval);

        this.animationInterval = setInterval(() => {
            this.cycleTiles();
        }, 3000);
    }

    private resetTilePositions(): void {
        this.tileContainer1.position.set(MaxGameWidthHeight / 2, 1150);
        this.tileContainer2.position.set(MaxGameWidthHeight, 1150);
        this.tileContainer3.position.set(MaxGameWidthHeight, 1150);
        this.tileIndex = 0;
        clearInterval(this.animationInterval);
    }

    private cycleTiles(): void {
        const currentTile = [this.tileContainer1, this.tileContainer2, this.tileContainer3][this.tileIndex];
        const nextTile = [this.tileContainer1, this.tileContainer2, this.tileContainer3][(this.tileIndex + 1) % 3];

        new Tween(currentTile.position, this.tweenGroupForTiles)
            .to({ x: 0 }, 500)
            .start();

        new Tween(nextTile.position, this.tweenGroupForTiles)
            .to({ x: MaxGameWidthHeight / 2 }, 500)
            .onComplete(() => {
                // Move currentTile to the far right after it exits the screen
                currentTile.position.set(MaxGameWidthHeight, 1150);
            })
            .start();

        this.tileIndex = (this.tileIndex + 1) % 3;
    }

}
